<div role="dialog" class="seds-modal-container">
  <div class="seds-modal">
    <div class="seds-modal-header seds-h5" mat-dialog-title>
      <div tabindex="0">
        <ng-content select="[header]"></ng-content>
      </div>
      <button aria-label="Fechar" class="seds-modal-close" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div tabindex="0" class="seds-modal-content seds-body" mat-dialog-content>
      <ng-content select="[content]"></ng-content>
    </div>
    <div class="seds-modal-footer" mat-dialog-actions>
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
